Auth = require 'app/scripts/db/auth'
LocalStorageModel = require 'app/scripts/view-models/internal/local-storage-model'
_ = require 'underscore'

module.exports = new class extends LocalStorageModel

  constructor: ->
    super()
    @set({ id: "memberState-#{ Auth.myId() }" })
    @fetch()

  default: -> {
    cardsPageSortType: 'board'
    cardsPageFilter: 'active-month'
    cardsPageGroup: 'all'
    processingAttachmentsLength: 0
    idCollapsedChecklists: []
    appcuesOptOut: false
}

  getCardsPageSortType: ->
    @get('cardsPageSortType')

  getCardsPageFilter: ->
    @get('cardsPageFilter')

  getCardsPageGroup: ->
    @get('cardsPageGroup')

  sortCardsPageByBoard: ->
    @save('cardsPageSortType', 'board')

  sortCardsPageByDate: ->
    @save('cardsPageSortType', 'date')

  setCardsPageFilter: (filter) ->
    @save('cardsPageFilter', filter)

  setCardsPageGroup: (group) ->
    @save('cardsPageGroup', group)

  getCollapsedChecklists: ->
    @get('idCollapsedChecklists')

  pullCollapsedChecklist: (idChecklist) ->
    @pull('idCollapsedChecklists', idChecklist)

  pushCollapsedChecklist: (idChecklist) ->
    @pull('idCollapsedChecklists', idChecklist)
    @addToSet('idCollapsedChecklists', idChecklist)
    collapsed = @getCollapsedChecklists()
    collapsedTrunc = _.rest(collapsed, Math.max(0, collapsed.length - 256))
    @save('idCollapsedChecklists', collapsedTrunc)

  getAppcuesOptOut: ->
    @get('appcuesOptOut')

  setAppcuesOptOut: (value) ->
    @save('appcuesOptOut', value)

  getBoardCollapsedPowerUps: ->
    @get('idBoardCollapsedPowerUps')

  pullBoardCollapsedPowerUps: (idBoard) ->
    @pull('idBoardCollapsedPowerUps', idBoard)

  pushBoardCollapsedPowerUps: (idBoard) ->
    @pull('idBoardCollapsedPowerUps', idBoard)
    @addToSet('idBoardCollapsedPowerUps', idBoard)
    collapsed = @getBoardCollapsedPowerUps()
    collapsedTrunc = _.rest(collapsed, Math.max(0, collapsed.length - 256))
    @save('idBoardCollapsedPowerUps', collapsedTrunc)
